<template>
  <v-container :class="{ 'px-0': $vuetify.breakpoint.smAndDown }">
    <v-row
      class="my-4 mx-auto"
      style="max-width: 500px"
    >
      <v-col cols="12">
        <h1 class="text-center accent--text mb-0">Вход</h1>
      </v-col>

      <v-col cols="12">
        <v-card
          class="card base-card shadow pa-8"
          @keydown.enter="!$v.form.$invalid && login()"
        >
          <v-row class="mx-0 mt-0">
            <v-col
              cols="12"
              class="pa-0 ma-0"
            >
              <v-text-field
                v-model="form.login"
                class="pa-0 pt-2 ma-0"
                label="Электронная почта"
                placeholder=" "
                :error-messages="loginErrors"
                @input="$v.form.login.$touch()"
                @blur="$v.form.login.$touch()"
              />
            </v-col>

            <v-col
              cols="12"
              class="pa-0 ma-0"
            >
              <v-text-field
                v-model="form.password.value"
                class="pt-3 ma-0"
                label="Пароль"
                placeholder=" "
                :type="form.password.type"
                :append-icon="form.password.icon"
                @click:append="form.password.changeVisible()"
                :error-messages="passwordErrors"
                @input="$v.form.password.value.$touch()"
                @blur="$v.form.password.value.$touch()"
              />
            </v-col>
          </v-row>

          <v-row class="mx-0 mb-0 d-flex justify-center">
            <v-col
              :cols="isMobile ? 12 : 4"
              class="pa-0 mt-4 d-flex justify-center"
            >
              <v-btn
                depressed
                color="primary"
                width="250"
                class="rounded-lg"
                :loading="loading"
                :disabled="$v.form.$invalid"
                @click="login"
              >
                <v-icon left>mdi-login-variant</v-icon>
                <span class="btn-text">Войти</span>
              </v-btn>
            </v-col>
          </v-row>

          <v-row class="mx-0 mb-0 d-flex justify-center">
            <v-col
              :cols="isMobile ? 12 : 4"
              class="pa-0 d-flex justify-center"
            >
              <v-btn
                text
                small
                color="primary"
                class="d-flex justify-center rounded-lg link-text"
                to="/forget"
              >
                Забыли пароль?
              </v-btn>
              <v-spacer v-if="!isMobile" />
              <v-btn
                text
                small
                color="primary"
                class="d-flex justify-center rounded-lg link-text"
                to="/registration"
              >
                Регистрация
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { required, maxLength } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'
import { formatLogin } from '@/scripts/formatLogin'
import { Login } from '@/models'

export default {
  name: 'Login',

  metaInfo: {
    title: 'Вход в Сервис учета информации о научных работах'
  },

  mounted() {
    this.onResize()
    window.addEventListener('resize', this.onResize)
  },

  destroyed() {
    window.removeEventListener('resize', this.onResize)
  },

  data: () => ({
    form: new Login(),
    loading: false,
    isMobile: false
  }),

  validations: {
    form: {
      login: {
        required,
        maxLength: maxLength(50)
      },
      password: {
        value: {
          required,
          maxLength: maxLength(50)
        }
      }
    }
  },

  computed: {
    ...mapGetters('user', ['isOperatorRoles']),

    loginErrors() {
      const errors = []
      if (!this.$v.form.login.$dirty) return errors
      !this.$v.form.login.maxLength && errors.push('Не больше 50 символов')
      return errors
    },
    passwordErrors() {
      const errors = []
      if (!this.$v.form.password.value.$dirty) return errors
      !this.$v.form.password.value.maxLength && errors.push('Не больше 50 символов')
      return errors
    }
  },

  methods: {
    onResize() {
      this.isMobile = window.innerWidth < 520
    },

    async findActualizationJournals() {
      try {
        const { journalEditorialBoardApi } = await import('@/api')
        const actualizeJournals = await journalEditorialBoardApi.findActualizationForCurrentUser()
        if (actualizeJournals.length)
          this.$toast.warning(
            `У вас есть работа в журнале, которую нужно актуализировать. Перейдите в раздел "Участие в работе редакционных коллегий журналов", актуализируйте статус участия и отправьте на проверку. `,
            {
              timeout: 10000,
              onClick: () => {
                this.$router.push('/journal-editorail-boards/journals')
              }
            }
          )
      } catch (e) {
        console.error(e)
      }
    },

    async login() {
      this.loading = true

      const body = {
        username: formatLogin(this.form.login),
        password: this.form.password.value
      }

      try {
        await this.$store.dispatch('user/login', body)
        await this.$router.push('/')
        await this.findActualizationJournals()
      } catch (e) {
        this.showErrorMessage(e, 'Неправильная пара логин-пароль')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.theme--light.v-btn.v-btn--disabled {
  color: white !important;
}

.theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text) {
  color: white !important;
}

.theme--light.v-tabs-items {
  background-color: transparent !important;
}

.theme--light.v-btn.v-btn--disabled .v-icon {
  color: white !important;
}

.card >>> .theme--light.v-label {
  color: rgba(55, 71, 79, 0.8) !important;
}

.card >>> .v-label.v-label--active.primary--text.theme--light {
  color: #2196f3 !important;
}
</style>
